import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import classes from './FieldWrapper.module.css';
export const FieldWrapper = ({ htmlType = 'div', label, children, labelClassName, className, }) => {
    // eslint-disable-next-line react/no-children-prop
    return React.createElement(htmlType, {
        children: (_jsxs(_Fragment, { children: [_jsx("span", { className: clsx(classes.label, labelClassName), children: label }), children] })),
        className: clsx(classes.wrapper, className),
    });
};
